import { useMemo } from 'react'

import { Alert } from '@vtex/shoreline'
import i from 'i18next'

import Panel from '~/components/Panel'

import { BannerAds } from './BannerAds'
import { ProductAds } from './ProductAds'
import { SponsoredBrandsAds } from './SponsoredBrandsAds'

type AdsPanelProps = {
  data: ResponseAds
}

export const AdsPanel = ({ data }: AdsPanelProps) => {
  const adType = useMemo(() => {
    const firstAd = data?.[0]

    if (!firstAd) return null

    if ('media_url' in firstAd) return 'banner'
    if ('product_name' in firstAd) return 'product'
    if ('assets' in firstAd) return 'sponsored_brand'

    return null
  }, [data])

  return (
    <>
      <Panel
        title="Ads"
        isCollapsible={!!data?.length}
        initialCollapsibleState={!!data?.length}
      >
        {!data?.length && (
          <Alert variant="warning">{i.t('c:messages.noResultsFound')}</Alert>
        )}

        {adType === 'banner' && <BannerAds ads={data as BannerAd[]} />}

        {adType === 'product' && <ProductAds ads={data as ProductAd[]} />}

        {adType === 'sponsored_brand' && (
          <SponsoredBrandsAds ads={data as SponsoredAdsResponse[]} />
        )}
      </Panel>
    </>
  )
}

export default AdsPanel
